export const DATE_FORMAT_FOR_API = 'yyyy-MM-dd';
export const DATE_PLACEHOLDER_FOR_DATE_PICKER = 'MM/DD/YYYY';
